<div class="fullscreen-container">
  <!-- Header -->
  <div class="dialog-header">
    <div class="header-left">
      <mat-icon class="header-icon">emoji_events</mat-icon>
      <div>
        <h2>Classificação Final</h2>
        <span class="header-subtitle">Passo {{ passoAtual + 1 }} de {{ totalPassos }} — Definindo o {{ passoCorrente.posicaoResultante }}º colocado</span>
      </div>
    </div>
    <div class="header-actions">
      <button *ngIf="temExcluidos" mat-icon-button (click)="toggleInfoExcluidos()"
              [matTooltip]="mostrarInfoExcluidos ? 'Ocultar informações' : 'Candidatos excluídos do processo'"
              tabindex="-1">
        <mat-icon>info_outline</mat-icon>
      </button>
      <button mat-icon-button (click)="fechar()" matTooltip="Fechar" tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Info excluídos (toggle) -->
  <div class="info-excluidos" [@expandCollapse]="mostrarInfoExcluidos ? 'expanded' : 'collapsed'">
    <div class="info-excluidos-content">
      <div *ngIf="dados.eliminados?.length" class="info-grupo">
        <strong>Eliminados:</strong>
        <div *ngFor="let e of dados.eliminados" class="info-item">
          <span class="info-nome">{{ e.nome }}</span>
          <span class="info-motivo">{{ e.motivo }}</span>
          <span class="info-fase">{{ e.fase }}</span>
        </div>
      </div>
      <div *ngIf="dados.ausentes?.length" class="info-grupo">
        <strong>Ausentes:</strong>
        <div *ngFor="let a of dados.ausentes" class="info-item">
          <span class="info-nome">{{ a.nome }}</span>
          <span class="info-motivo">{{ a.motivo }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Corpo principal: conteúdo + sidebar -->
  <div class="dialog-body">
    <div class="main-layout">
      <!-- Conteúdo principal -->
      <div class="main-content">
        <!-- Barra de progresso -->
        <div class="progress-wrapper">
          <div class="progress-bar-container">
            <div class="progress-bar-fill" [style.width.%]="progresso"></div>
          </div>
        </div>

        <!-- Passo atual -->
        <div class="passo-content" [@fadeSlide]="passoAtual" *ngIf="passoCorrente">

          <!-- QUADRO DE EXAMINADORES (foco principal, sempre visível) -->
          <div class="secao-card">
            <div class="secao-titulo">
              <mat-icon>groups</mat-icon>
              <span>Classificação Individual dos Examinadores</span>
            </div>
            <div class="quadro-examinadores">
              <table class="tabela-quadro">
                <thead>
                  <tr>
                    <th class="col-posicao">Pos.</th>
                    <th *ngFor="let ex of passoCorrente.quadroExaminadores" class="col-examinador">
                      {{ ex.nome }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let posIdx of posicaoArray">
                    <td class="col-posicao">{{ posIdx + 1 }}ª</td>
                    <td *ngFor="let ex of passoCorrente.quadroExaminadores"
                        [class.primeiro]="posIdx === 0"
                        [class.classificado-cell]="posIdx === 0 && isClassificado(passoCorrente, getCandidatoNaPos(ex, posIdx)?.inscricaoId)">
                      {{ getCandidatoNaPos(ex, posIdx)?.nome || '—' }}
                      <img *ngIf="getCandidatoNaPos(ex, posIdx)?.pcd" src="assets/icons/Accessibility_logo.png" class="pcd-icon" matTooltip="Pessoa com Deficiência" alt="PCD">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- CONTAGEM DE INDICAÇÕES -->
          <div class="secao-card">
            <div class="secao-titulo">
              <mat-icon>how_to_vote</mat-icon>
              <span>Indicações na 1ª Posição</span>
              <span class="secao-subtitulo">— Quantos examinadores colocaram o candidato em 1º lugar</span>
            </div>
            <div class="contagem-container">
              <div *ngFor="let item of passoCorrente.contagem" class="contagem-linha"
                   [class.vencedor]="isClassificado(passoCorrente, item.inscricaoId)">
                <span class="contagem-nome">
                  {{ item.nome }}
                  <img *ngIf="item.pcd" src="assets/icons/Accessibility_logo.png" class="pcd-icon" matTooltip="Pessoa com Deficiência" alt="PCD">
                </span>
                <div class="contagem-barra-container">
                  <div class="contagem-barra" [style.width]="getBarWidth(item.indicacoes)"
                       [class.barra-vencedor]="isClassificado(passoCorrente, item.inscricaoId)">
                    {{ item.indicacoes }} de {{ passoCorrente.quadroExaminadores.length }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- RESULTADO DO PASSO (clicável para expandir desempate) -->
          <div class="resultado-wrapper" [class.empate-wrapper]="passoCorrente.empate">
            <div class="resultado-card" @fadeIn
                 [class.resultado-empate]="passoCorrente.empate"
                 [class.resultado-expandido]="passoCorrente.empate && isDetalhesExpandido(passoAtual)"
                 (click)="passoCorrente.empate && temDesempateResolvido(passoCorrente) ? toggleDetalhes(passoAtual) : null"
                 [class.clicavel]="passoCorrente.empate && temDesempateResolvido(passoCorrente)">
              <mat-icon class="resultado-icone">{{ passoCorrente.empate ? 'balance' : 'emoji_events' }}</mat-icon>
              <div class="resultado-info">
                <span class="resultado-label">{{ passoCorrente.posicaoResultante }}º Classificado:</span>
                <span class="resultado-nome">{{ getNomeClassificado(passoCorrente) }}</span>
                <span *ngIf="passoCorrente.empate" class="resultado-empate-texto">
                  Empate — desempate aplicado conforme critérios do edital
                </span>
              </div>
              <mat-icon *ngIf="passoCorrente.empate && temDesempateResolvido(passoCorrente)" class="resultado-expand-icon">
                {{ isDetalhesExpandido(passoAtual) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </div>

            <!-- DETALHES DO DESEMPATE (colado, colapsado por default) -->
            <div *ngIf="passoCorrente.empate && temDesempateResolvido(passoCorrente)"
                 [@expandCollapse]="isDetalhesExpandido(passoAtual) ? 'expanded' : 'collapsed'">
              <div class="desempate-bloco">
                <div class="desempate-titulo">
                  <mat-icon>balance</mat-icon>
                  <span>Ordem de desempate</span>
                </div>
                <div class="desempate-lista">
                  <div *ngFor="let item of getEmpatadosOrdenados(passoCorrente)" class="desempate-item">
                    <span class="desempate-conceito" *ngIf="item.conceito">{{ item.conceito }}</span>
                    <span class="desempate-nome">{{ item.nome }}</span>
                    <span class="desempate-justificativa" *ngIf="item.justificativaDesempate">{{ item.justificativaDesempate }}</span>
                    <span class="desempate-pendente" *ngIf="!item.conceito && !item.justificativaDesempate">Pendente de resolução</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SIDEBAR: Classificação acumulada (sempre aberta) -->
      <div class="sidebar-classificacao">
        <div class="sidebar-header">
          <mat-icon>format_list_numbered</mat-icon>
          <span>Classificação</span>
        </div>
        <div class="sidebar-body">
          <div *ngIf="classificadosAteAgora.length === 0" class="sidebar-vazio">
            Avance nos passos para visualizar a classificação.
          </div>
          <div class="sidebar-lista">
            <ng-container *ngFor="let c of classificadosAteAgora; let i = index">
              <div *ngIf="i > 0 && c.posicao !== classificadosAteAgora[i-1].posicao" class="sidebar-separator"></div>
              <div class="sidebar-item" @sidebarItem [style.padding-left.px]="(c.posicao - 1) * 12 + 8">
                <span class="sidebar-posicao">{{ c.posicao }}º</span>
                <span *ngIf="c.conceito" class="sidebar-conceito">{{ c.conceito }}</span>
                <span class="sidebar-nome">{{ c.nome }}</span>
                <img *ngIf="c.pcd" src="assets/icons/Accessibility_logo.png" class="pcd-icon" matTooltip="Pessoa com Deficiência" alt="PCD">
                <mat-icon *ngIf="c.justificativa"
                          class="sidebar-desempate-icon"
                          [matTooltip]="c.justificativa"
                          matTooltipClass="desempate-tooltip">
                  balance
                </mat-icon>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Navegação no rodapé -->
  <div class="navegacao-footer">
    <button mat-raised-button color="primary" (click)="voltar()" [disabled]="passoAtual === 0" class="btn-nav">
      <mat-icon>arrow_back</mat-icon>
      {{ passoAtual > 0 ? 'Voltar — ' + getPosicaoAnterior() + 'º colocado' : 'Anterior' }}
    </button>
    <button mat-raised-button color="primary" (click)="avancar()" [disabled]="passoAtual === totalPassos - 1" class="btn-nav">
      {{ passoAtual < totalPassos - 1 ? 'Próximo — ' + getPosicaoProxima() + 'º colocado' : 'Próximo' }}
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
